import { render } from "./paralisarFormComponent.vue?vue&type=template&id=93bc4ef4"
import script from "./paralisarFormComponent.vue?vue&type=script&lang=js"
export * from "./paralisarFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Dashboard/components/paralisarFormComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "93bc4ef4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('93bc4ef4', __exports__)) {
    console.log('reload')
    api.reload('93bc4ef4', __exports__)
  }
  
  module.hot.accept("./paralisarFormComponent.vue?vue&type=template&id=93bc4ef4", () => {
    console.log('re-render')
    api.rerender('93bc4ef4', render)
  })

}


export default __exports__